module.exports = __webpack_public_path__ + "img/ug.e1ed53ec.jpg";